const defaultFn = () => {
	// tslint:disable-next-line
	console.log(`please define a TableDisplayable fn for ${this}`);
};

export const TableDisplayable = (fnName?: string) => {
	// tslint:disable-next-line
	return <T extends { new (...args: any[]): {} }>(constructor: T) => {
		if (typeof fnName === 'undefined') {
			return class extends constructor {
				displayForTable = defaultFn.bind(this);
			};
		} else {
			return class extends constructor {
				displayForTable = this[fnName];
			};
		}
	};
};
